<template>
    <div class="corporateCultureBox">
        <aboutBannerVue tabIndex="4"></aboutBannerVue>
        <TypicalAchievement :show-tabs="true" :show-all-tab="true" :show-sidebar="true" />
    </div>
</template>

<script>
import aboutBannerVue from '@/components/aboutBanner'
import TypicalAchievement from '@/components/TypicalAchievement.vue'

export default {
    name: 'TypicalPerformance',
    components: { aboutBannerVue, TypicalAchievement }
}
</script>

<style scoped>
.corporateCultureBox {
    padding-bottom: 30px;
}
</style>
